































































/* eslint dot-notation: 0 */
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
const namespace: string = "authentication";

@Component
export default class Header extends Vue {
    // searchFocused: boolean = false;
    shadow: boolean = false;
    scroll: any;

    channelId: string = "";
    update = 0;
    breadCrumbs: any = null;
    displayBreadCrumbs: any = null;
    icon: string = "";

    handler(): void {
        this.$emit("sidebar-toggle");
    }

    support() {
        this.$router.push("/support");
    }
}
